import {Mutation, MutationAction, Action, VuexModule, getModule, Module} from 'vuex-module-decorators';
import store from '@/classes/core/store';
import {OsLoader} from '@/classes/app/os/os-loader';
import {ownersiteModule} from '@/store/ownersite';
import {IOsGalleryContent} from '@/classes/domain/module/os/gallery/i-os-gallery-content';

export interface IOsGalleryParam {
    galleryId?: string | null;
    categoryId?: string | null;
}

// state's interface
export interface IOsGalleryModule {
    content: IOsGalleryContent | null;
    param: IOsGalleryParam | null;
}

@Module({dynamic: true, store, name: 'osGalleryDetail', namespaced: true})
class Store extends VuexModule implements IOsGalleryModule {

    // Page data
    public param: IOsGalleryParam = {
        galleryId: null,
        categoryId: null
    };
    public content: IOsGalleryContent | null = null;

    @Mutation
    public updateParam(value: IOsGalleryParam) {
        this.param = value;
    }

    @Mutation
    public updateContent(value: IOsGalleryContent) {
        this.content = value;
    }

    @Action
    public async fetch() {

        // console.log('Dummy pj', JSON.stringify(DummyProject));
        // console.log('Dummy page home', JSON.stringify(DummyPageGallery));
        const page = await OsLoader.load('gallery', this.param);
        ownersiteModule.updateProject(page.project);
        osGalleryModule.updateContent(page.content);
    }
}

export const osGalleryModule = getModule(Store);

